<template>
  <router-link :to="location">
    <slot>{{label}}</slot>
  </router-link>
</template>

<script>
export default {
  name: 'RushRacePlayerLink',

  props: {
    rushRaceId: {
      type: Object,
      required: true
    },

    playerId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'racer'
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const id = this.rushRaceId;

      const loc = {
        name: 'rush_race_player',
        params: {
          rushId:   id.rushId,
          raceId:   id.raceId,
          playerId: this.playerId,
        }
      };

      return loc;
    },
  }
};
</script>
